import { TASK_CARD_SETS } from "@/data/taskCards";

const GOLD = "#F5A524";

// Table of contents — page 2 of the booklet. Lists every card grouped by set,
// with the page number it appears on. `startPage` is the page of the first
// card (cover = 1, this TOC = 2, first card = 3).
export default function TocSheet({ lang = "en", startPage = 3 }) {
  const tr = (o) => (o && (o[lang] || o.en)) || "";
  const t = (en, es) => (lang === "es" ? es : en);

  // Continuous page numbering across all sets in their natural order.
  let page = startPage;
  const sets = TASK_CARD_SETS.map((set) => {
    const cards = set.cards.map((c) => ({ id: c.id, title: tr(c.title), page: page++ }));
    return { id: set.id, color: set.color, title: tr(set.title), cards };
  });

  // Two balanced columns: [essentials, genres] | [creative, wildlife].
  const colA = sets.slice(0, 2);
  const colB = sets.slice(2);

  return (
    <div
      data-sheet
      data-testid="task-sheet-toc"
      style={{ width: 816, height: 1056, background: "#ffffff", color: "#18181B", position: "relative", overflow: "hidden", fontFamily: "'Outfit', system-ui, sans-serif" }}
    >
      {/* header banner */}
      <div style={{ background: `linear-gradient(135deg, ${GOLD} 0%, #C97D0A 100%)`, color: "#fff", padding: "20px 56px 16px", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", right: -40, top: -50, width: 190, height: 190, borderRadius: "50%", background: "rgba(255,255,255,0.12)" }} />
        <div style={{ position: "relative" }}>
          <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase", color: "rgba(255,255,255,0.85)" }}>DSLR Advisor&trade;</span>
          <h1 style={{ fontSize: 38, fontWeight: 800, margin: "3px 0 0", letterSpacing: "-0.025em" }}>{t("Contents", "Contenido")}</h1>
        </div>
      </div>

      <div style={{ display: "flex", gap: 36, padding: "22px 56px 0" }}>
        {[colA, colB].map((col, ci) => (
          <div key={ci} style={{ flex: 1 }}>
            {col.map((set) => (
              <div key={set.id} style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 7 }}>
                  <span style={{ width: 12, height: 12, borderRadius: 4, background: set.color }} />
                  <span style={{ fontSize: 14, fontWeight: 800, letterSpacing: "0.04em", textTransform: "uppercase", color: set.color }}>{set.title}</span>
                </div>
                {set.cards.map((c) => (
                  <div key={c.id} style={{ display: "flex", alignItems: "baseline", gap: 8, padding: "2.5px 0", borderBottom: "1px solid #F0F0F2", lineHeight: 1.3 }}>
                    <span style={{ fontSize: 14, fontWeight: 500, color: "#3F3F46", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>{c.title}</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: set.color, fontFamily: "'JetBrains Mono', monospace" }}>{c.page}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, background: "#18181B", color: "#fff", padding: "14px 56px", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, fontWeight: 600 }}>
        <span style={{ color: GOLD }}>★ {t("FREE printable booklet", "Folleto imprimible GRATIS")}</span>
        <span>www.dslradvisor.com</span>
      </div>
    </div>
  );
}
